<template>
  <div>
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-12 pb-2">
          <label for="columndate">Tipo Fecha</label>
          <el-select v-model="search.columndate" placeholder="Select" @change="changeClearInput">
            <el-option v-for="(label, key) in columnsDates" :key="key" :value="key" :label="label"></el-option>
          </el-select>
      </div>

      <template v-if="search.columndate === 'created_at'">
        <div class="col-lg-2 col-md-2 col-sm-12">
          <label for="xxx">Fecha</label>
          <el-date-picker
            v-model="search.date"
            type="date"
            style="width: 100%;"
            placeholder="Buscar"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </template>
      
      <template v-if="search.columndate === 'between_dates'">
        <div class="col-md-2">
          <div class="form-group">
            <label for="xxx">Desde</label>
            <el-date-picker
              v-model="search.desde"
              type="date"
              style="width: 100%;"
              placeholder="Desde"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="xxx">Hasta</label>
            <el-date-picker
              v-model="search.hasta"
              type="date"
              style="width: 100%;"
              placeholder="Hasta"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
      </template>

      <div class="col-lg-2 col-md-2 col-sm-12 pb-2">
        <label for="xxx">Filtrar por</label>
        <el-select v-model="search.column" placeholder="Select" @change="changeClearInput">
          <el-option v-for="(label, key) in columns" :key="key" :value="key" :label="label"></el-option>
        </el-select>
      </div>

      <template v-if="search.column === 'for_destine'">
        <div class="col-lg-2 col-md-2 col-sm-12 ">
          <div class="form-group">
            <label for="xxx">Almacén Inicial</label>
            <el-select v-model="search.alm_inicial" placeholder="Seleccione un almacén" filterable default-first-option>
              <el-option
                v-for="option in warehouses"
                :key="option.id"
                :value="option.id"
                :label="option.description" style="width: 100%;"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 ">
          <div class="form-group">
            <label for="xxx">Almacén Destino</label>
            <el-select v-model="search.alm_destino" placeholder="Seleccione un almacén" filterable default-first-option>
              <el-option
                v-for="option in warehouses"
                :key="option.id"
                :value="option.id"
                :label="option.description" style="width: 100%;"
              ></el-option>
            </el-select>
          </div>
        </div>
      </template>

      <template v-if="search.column === 'warehouse_id' || search.column === 'warehouse_destination_id'">
        <div class="col-lg-2 col-md-2 col-sm-12 ">
          <label for="xxx">Almacén</label>
          <el-select v-model="search.value" placeholder="Seleccione un almacén" filterable default-first-option>
            <el-option
              v-for="option in warehouses"
              :key="option.id"
              :value="option.id"
              :label="option.description" style="width: 100%;"
            ></el-option>
          </el-select>
        </div>
      </template>


      <div class="col-lg-12 col-md-12 col-sm-12">
        <el-button type="primary" @click="getRecords">Buscar</el-button>
        <el-button type="danger" @click.prevent="impresionDetallada('pdf')"><i class="fas fa-file-pdf"></i> Imprimir Detallado</el-button>
        <el-button type="success" @click.prevent="impresionDetallada('xls')"><i class="fas fa-file-excel"></i> Exportar Detallado</el-button>
      </div>
    </div>


    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <slot name="heading"></slot>
          </thead>
          <tbody>
            <slot v-for="(row, index) in records" :row="row" :index="customIndex(index)"></slot>
          </tbody>
        </table>
        <div>
          <el-pagination
            @current-change="getRecords"
            layout="total, prev, pager, next"
            :total="pagination.total"
            :current-page.sync="pagination.current_page"
            :page-size="pagination.per_page"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment";
import queryString from "query-string";

export default {
  props: {
    resource: String
  },
  data() {
    return {
      search: {
        column: null,
        value: null,
        columndate: "created_at",
        date: null,
        desde: null,
        hasta: null,
        alm_destino:null,
        alm_inicial:null,
      },
      columnsDates: {
        created_at: "Fecha de emisión",
        between_dates: "Entre fechas",
      },
      columns: [],
      records: [],
      dialogVisible:false,
      warehouses: [],
      filtro:{
        desde: new Date(),
        hasta: new Date(),
        alm_destino:null,
        alm_inicial:null,
      },
      pagination: {}
    };
  },
  computed: {},
  created() {
    this.$eventHub.$on("reloadData", () => {
      // this.getRecords();
    });
  },
  async mounted() {
    let column_resource = _.split(this.resource, "/");
    // console.log(column_resource)
    await this.$http
      .get(`/${_.head(column_resource)}/columns`)
      .then(response => {
        this.columns = response.data;
        this.search.column = _.head(Object.keys(this.columns));
      });
    // await this.getRecords();
    await this.getWarehouses();
  },
  methods: {
    customIndex(index) {
      return (
        this.pagination.per_page * (this.pagination.current_page - 1) +
        index +
        1
      );
    },
    getWarehouses(){
        return this.$http.get(`/${this.resource}/tables`).then(response => {
            this.warehouses = response.data.warehouses;
        });
    },
    getRecords() {

      if (this.search.columndate === 'created_at') {
        if (!this.search.date) {
          this.$message.error('Debe seleccionar una fecha');
          return; 
        }
      }

      if (this.search.columndate === 'between_dates') {
        if (!this.search.desde || !this.search.hasta) {
          this.$message.error('Debe seleccionar las fechas "Desde" y "Hasta"');
          return;
        }
      }

      if ((this.search.column === 'warehouse_id' || this.search.column === 'warehouse_destination_id') && !this.search.value) {
        this.$message.error('Debe seleccionar un valor para el almacén');
        return;
      }

      if (this.search.column === 'for_destine') {
        if (!this.search.alm_inicial || !this.search.alm_destino) {
          this.$message.error('Debe seleccionar tanto el almacén inicial como el destino');
          return; 
        }
      }

      return this.$http
        .get(`/${this.resource}/records?${this.getQueryParameters()}`)
        .then(response => {
          // console.log(response.data.data)
          this.records = response.data.data;
          this.pagination = response.data.meta;
          this.pagination.per_page = parseInt(response.data.meta.per_page);
        });
    },
    getQueryParameters() {
      let params = {
        page: this.pagination.current_page,
        limit: this.pagination.per_page,
        ...this.search
      };

      // Si se seleccionó un filtro de fechas entre fechas (from - to)
      if (this.search.column === 'between_dates') {
        // Asegurarnos de que las fechas estén correctamente formateadas a YYYY-MM-DD
        params.desde = moment(this.search.desde).format('YYYY-MM-DD');
        params.hasta = moment(this.search.hasta).format('YYYY-MM-DD');
      }

      // Para created_at, no es necesario modificar el valor si ya está en formato adecuado
      if (this.search.column === 'created_at') {
        params.date = moment(this.search.date).format('YYYY-MM-DD');
      }

      return queryString.stringify(params);
    },

    // getQueryParameters() {
    //   return queryString.stringify({
    //     page: this.pagination.current_page,
    //     limit: this.limit,
    //     ...this.search
    //   });
    // },
    changeClearInput() {
      this.search.value = "";
      if (this.search.column !== 'between_dates') {
        this.search.desde = null;
        this.search.hasta = null;
      }
      // this.getRecords();
    },
    impresionDetallada(type){
      console.log(this.records)
        this.$http.post(`/${this.resource}/impresion-detallada?${this.getQueryParameters()}`,{
            'type': type,
            // 'records': this.records,
        },{ responseType: 'blob' })
        .then(response=>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            const filename = 'Reporte_Traslado_Detallado.'+ type
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        })
    },
    // goBusqueda(){
    //     //console.log(this.filtro)
    //     if(this.filtro.desde && this.filtro.hasta){
    //         const zloading = this.$loading({
    //             lock: true,
    //             text: 'Iniciando busqueda',
    //             spinner: 'el-icon-loading',
    //             background: 'rgba(0, 0, 0, 0.7)'
    //         });
    //         const data = this.filtro
    //         return this.$http
    //                 .post(`/${this.resource}/records/busqueda`,data)
    //                 .then(response => {
    //                     zloading.close()
    //                     this.records = response.data.data;
    //                     this.pagination = response.data.meta;
    //                     this.pagination.per_page = parseInt(response.data.meta.per_page);
    //                     this.dialogVisible = false
    //                 })
    //                 .catch(error=>{
    //                     zloading.close()
    //                     console.log(error)
    //                 });
    //     }else{
    //         this.$message({
    //             showClose: true,
    //             message: 'Las fechas son necesarias para la busqueda.',
    //             type: 'warning'
    //         })
    //     }
    // }
  }
};
</script>
